var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-question-analysis" },
    [
      _c("div", { staticClass: "answer-box active" }, [
        _c("div", { staticClass: "p1" }, [
          _c("div", { staticStyle: { flex: "1" } }, [
            _c("p", [
              _vm._v(" 您的答案： "),
              (
                _vm.analysisDatas.choice_correct_item ||
                _vm.analysisDatas.choice_correct_thumb
                  ? true
                  : false
              )
                ? _c("span", { staticClass: "oringe mar40" }, [
                    _vm._v(_vm._s(_vm._f("getAnswer")(_vm.analysisDatas))),
                  ])
                : _c("span", { staticClass: "oringe mar40" }, [
                    _vm._v("未作答"),
                  ]),
            ]),
            Array.isArray(_vm.analysisDatas.choice_correct_thumb)
              ? _c(
                  "div",
                  _vm._l(
                    _vm.analysisDatas.choice_correct_thumb,
                    function (item, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          _c("el-image", {
                            staticClass: "mat20 mar10",
                            staticStyle: { width: "100px", color: "#fff" },
                            attrs: {
                              fit: "contain",
                              src: item,
                              "preview-src-list": [item],
                            },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  0
                )
              : (_vm.analysisDatas.choice_correct_thumb ? true : false)
              ? _c(
                  "div",
                  _vm._l(
                    _vm.analysisDatas.choice_correct_thumb.split(","),
                    function (item, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          _c("el-image", {
                            staticClass: "mat20 mar10",
                            staticStyle: { width: "100px", color: "#fff" },
                            attrs: {
                              fit: "contain",
                              src: item,
                              "preview-src-list": [item],
                            },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  0
                )
              : _vm._e(),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.analysisDatas.question_style !== 5,
                    expression: "analysisDatas.question_style !== 5",
                  },
                ],
                staticClass: "mat30",
                staticStyle: { display: "flex" },
              },
              [
                _vm._v(" 参考答案： "),
                _c(
                  "span",
                  {
                    staticClass: "yes",
                    staticStyle: { "line-height": "24px" },
                  },
                  [_vm._v(_vm._s(_vm._f("getCorrect")(_vm.analysisDatas)))]
                ),
              ]
            ),
          ]),
          _vm.makeType !== 7
            ? _c("p", [
                _c(
                  "span",
                  {
                    staticClass: "opera",
                    class: _vm.isCollect ? "oringe" : "",
                    on: { click: _vm.changeCollect },
                  },
                  [
                    _c("i", { staticClass: "iconfont iconshoucang1 mar5" }),
                    _vm._v("收藏 "),
                  ]
                ),
                _c(
                  "span",
                  {
                    staticClass: "opera",
                    on: {
                      click: function ($event) {
                        _vm.correctVisible = !_vm.correctVisible
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "iconfont iconcuotiku mar5" }),
                    _vm._v("纠错 "),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "p2" }, [
          _vm._v(" 参考解析： "),
          _c(
            "div",
            { staticClass: "resolve" },
            [
              _c("p", {
                staticStyle: {
                  "line-height": "24px",
                  "white-space": "pre-line",
                },
                domProps: { innerHTML: _vm._s(_vm.analysisDatas.analysis) },
              }),
              _vm.analysisDatas.analyze_thumb
                ? _c("el-image", {
                    staticClass: "mat20",
                    staticStyle: { width: "100px", color: "#fff" },
                    attrs: {
                      fit: "contain",
                      src: _vm.analysisDatas.analyze_thumb,
                      "preview-src-list": [_vm.analysisDatas.analyze_thumb],
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm.analysisDatas.source
          ? _c("div", { staticClass: "mat30" }, [
              _vm._v(" 知识点来源：" + _vm._s(_vm.analysisDatas.source) + " "),
            ])
          : _vm._e(),
        _vm.makeType !== 7
          ? _c("div", { staticClass: "note-box" }, [
              _c("div", { staticClass: "my-note mat10" }, [
                _vm._v(" 我的笔记： "),
                _c("div", [
                  _c(
                    "p",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "note-btn",
                          attrs: { type: "warning" },
                          on: {
                            click: function ($event) {
                              _vm.isShowTextArea = !_vm.isShowTextArea
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "iconfont iconbi" }),
                          _vm._v(" 记笔记 "),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    {
                      staticClass: "textarea-box",
                      class: _vm.isShowTextArea ? "active" : "",
                    },
                    [
                      _c("el-input", {
                        staticClass: "input mar10",
                        attrs: { type: "textarea", rows: "4" },
                        model: {
                          value: _vm.noteContent,
                          callback: function ($$v) {
                            _vm.noteContent = $$v
                          },
                          expression: "noteContent",
                        },
                      }),
                      _c("el-button", { on: { click: _vm.saveNotes } }, [
                        _vm._v("提交"),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm.noteList && _vm.noteList.length > 0
                ? _c(
                    "div",
                    { staticClass: "note-list" },
                    [
                      _c(
                        "el-timeline",
                        { attrs: { reverse: true } },
                        _vm._l(_vm.noteList, function (activity, index) {
                          return _c(
                            "el-timeline-item",
                            {
                              key: index,
                              attrs: {
                                type: "primary",
                                icon: "el-icon-time",
                                size: "large",
                                placement: "top",
                                timestamp: activity.created_at,
                              },
                            },
                            [_vm._v(_vm._s(activity.content))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      _c("ComponentCorrect", {
        attrs: {
          topicId: _vm.analysisDatas.question_id,
          visible: _vm.correctVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.correctVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }